// @TODO remove the whole file after testing indexed db implementation
// commented bacauset the loader is not hiding since members store is empty
/* eslint-disable @typescript-eslint/no-unused-vars */
import { fromPairs, intersection, keyBy, union, uniq } from 'lodash';
import { ProjectId, User } from 'api/models';
import {
  ProjectUsersByAccess,
  UsersMetadata,
} from 'components/organisms/tasks/fields';
import { MembershipsStore } from 'stores/memberships';
import { UsersStore } from 'stores/users';
import { memoForCallbacks } from 'utils/memoForCallbacks';

export const constructUserMeta = memoForCallbacks(
  ({
    membershipsStore,
    active_user_ids,
    projectIds,
    users_list,
    currentUser,
    non_external_user_ids,
  }: {
    membershipsStore: MembershipsStore;
    usersStore: UsersStore;
    current_company_user_ids: number[];
    native_user_ids: number[];
    active_user_ids: number[];
    non_external_user_ids: number[];
    current_company_active_user_ids: number[];
    projectIds: ProjectId[];
    users_list: User[];
    currentUser: User;
  }): UsersMetadata => {
    const getTupleById = (projectId) => {
      const [_, _projectId] = projectId;
      const memberships =
        MembershipsStore.ofProject(projectId)(membershipsStore);
      const project_member_ids = memberships[1]?.users ?? [];

      const project_users: ProjectUsersByAccess = {
        private: {
          in_project_user_ids: intersection(
            project_member_ids,
            active_user_ids,
          ),
          not_in_project_user_ids: [],
        },
        shared: {
          in_project_user_ids: intersection(
            project_member_ids,
            active_user_ids,
          ),
          not_in_project_user_ids: [],
        },
      };

      return [projectId[1], project_users, active_user_ids] as [
        number,
        ProjectUsersByAccess,
        number[],
      ];
    };

    const tuples = projectIds.map(getTupleById);
    const by_user_id = keyBy(users_list, 'userId');

    const active_users_ids_from_all_projects = tuples.reduce(
      (all_active, [, , shared_active]) => {
        all_active.push(...shared_active);

        return all_active;
      },
      [] as number[],
    );
    const unique_active_users_ids_from_all_projects = [
      ...new Set(active_users_ids_from_all_projects),
    ];
    const users = {
      active_user_ids: unique_active_users_ids_from_all_projects,
      non_external_user_ids,
      by_user_id,
      by_project_id: fromPairs(tuples),
    } as UsersMetadata;

    return users;
  },
  (old, cur) => {
    if (!old) {
      return false;
    }
    if (!cur) {
      return false;
    }
    let areEqual = true;

    // note to future refactors.
    // Here if conditions can't be swapped because all user count change is directly related to active user count. SO swapping condition would likely to show an stale data
    if (old.projectIds?.length !== cur.projectIds?.length) {
      areEqual = false;
    }
    if (old.active_user_ids?.length !== cur.active_user_ids?.length) {
      areEqual = false;
    }
    if (old.native_user_ids?.length !== cur.native_user_ids?.length) {
      areEqual = false;
    }
    if (
      old.current_company_active_user_ids?.length !==
      cur.current_company_active_user_ids?.length
    ) {
      areEqual = false;
    }
    if (
      old.current_company_user_ids?.length !==
      cur.current_company_user_ids?.length
    ) {
      areEqual = false;
    }
    if (old.membershipsStore !== cur.membershipsStore) {
      areEqual = false;
    }
    if (old.usersStore !== cur.usersStore) {
      areEqual = false;
    }
    if (areEqual) {
      return true;
    }

    return false;
  },
);
